
import { defineComponent, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { services } from '@/services/services'
import { apiErrorMessage } from '@/apiErrorMessage'
import DismissibleAlert from '@/views/components/DismissibleAlert.vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import { NoticeItem } from '@/repositories/system/noticeRepository'
import { callApiWrapper } from '@/views/callApiWrapper'

const loginService = services.login

export default defineComponent({
  components: {
    LoadingButton,
    DismissibleAlert
  },
  setup () {
    const router = useRouter()
    const store = useStore()
    const loginId = ref('')
    const password = ref('')
    const loading = ref(false)
    const errorMessage = ref<string | null>(null)
    const notices = ref<NoticeItem[]>([])

    onMounted(async () => {
      const route = useRoute()
      if (route.query.sessionTimeout) {
        errorMessage.value = apiErrorMessage.sessionTimeout
      }
      await callApiWrapper(errorMessage, async () => {
        notices.value = await loginService.getNotices()
      })
    })

    const tryLogin = async () => {
      errorMessage.value = null
      loading.value = true
      try {
        await loginService.tryLogin(loginId.value, password.value)
        await store.dispatch('userStatus/update')
        await router.push('/top')
      } catch (e) {
        errorMessage.value = 'ログインに失敗しました。'
      } finally {
        loading.value = false
      }
    }

    return {
      loginId,
      password,
      loading,
      errorMessage,
      notices,
      tryLogin
    }
  }
})
